import { findElements } from 'dom-helper';
import Modal from './modal';
import Mason from './mason';
import BrickConfigClassMap from '../utils/brick_config_class_map';

export default class BrickModal extends Modal {

  static showBrick(brickConfig, heightOffset = null) {
    const modalBrickId = '__gwi-mobile-brick-holder';
    const iFrameHtml = `<div id="${modalBrickId}"></div>`;
    const BrickConfigClass = BrickConfigClassMap.get(brickConfig.brickType);
    const mobileBrickConfig = new BrickConfigClass({ isModalBrick: true });
    mobileBrickConfig.merge(brickConfig);

    BrickModal.show(iFrameHtml, heightOffset);
    const element = findElements(`#${modalBrickId}`)[0];

    return Mason.build(element, mobileBrickConfig);
  }

  static getMobileModalDimensions() {
    return {
      width: '100%',
      height: '95%',
    };
  }
}



// WEBPACK FOOTER //
// ./src/models/brick-modal.js